import React from 'react';

import ListMyCampaigns from '../../campaigns/ListMyCampaigns';
import Titled from '../../layout/Titled';
import { sessionShape } from '../../prop-types';
import withSessionInfo from '../../signin/with-session-info';

class AdOpsDashboard extends React.PureComponent {
  render() {
    const { session } = this.props;

    if (!(session && session.user)) return null;

    return (
      <Titled title="My Campaigns">
        <ListMyCampaigns relevantFor={session.user.id} />
      </Titled>
    );
  }
}

AdOpsDashboard.propTypes = {
  session: sessionShape,
};

AdOpsDashboard.defaultProps = {
  session: null,
};

export default withSessionInfo(AdOpsDashboard);
